/**
 * Tenant Features Service
 * TASK-428: Per-tenant UI feature flags for the cockpit feature registry.
 *
 * Reads/writes the account's `features` map via the auth-service admin API,
 * proxied through the gateway. Mirrors asrSettingsService.
 */

import { httpClient } from '../../lib/httpClient';
import { logger } from '../../utils/logger';
import type { TenantFeatures, TenantFeaturesData } from '../../types/admin';

class FeaturesService {
  private readonly basePath = '/api/admin/features';

  /** Get the per-tenant feature flags for the current account. */
  async getFeatures(): Promise<TenantFeatures> {
    try {
      const data = await httpClient.get<TenantFeaturesData>(this.basePath);
      return data.features ?? {};
    } catch (error) {
      logger.error('Error fetching tenant features:', error);
      throw error;
    }
  }

  /** Merge-update the feature flags. Provided keys overwrite; others untouched. */
  async updateFeatures(features: TenantFeatures): Promise<TenantFeatures> {
    try {
      const data = await httpClient.put<TenantFeaturesData>(this.basePath, { features });
      return data.features ?? {};
    } catch (error) {
      logger.error('Error updating tenant features:', error);
      throw error;
    }
  }
}

export const featuresService = new FeaturesService();
